import { withTwoDigits } from "./withTwoDigits";

export const formatDate = (date: Date | string | null): string => {
  let actualDate = date;

  if (!actualDate) {
    return "";
  }

  if (typeof actualDate === "string") {
    actualDate = new Date(actualDate);
  }

  if (Object.prototype.toString.call(actualDate) !== "[object Date]") {
    return "";
  }

  return `${withTwoDigits(actualDate.getDate())}/${withTwoDigits(
    actualDate.getMonth() + 1,
  )}/${withTwoDigits(actualDate.getFullYear())}`;
};
